import React, { Component } from 'react';

class IconTicketEmail extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                <path
                    fill="#424242"
                    d="M23.55 4.74a2.4 2.4 0 00-.4-.38A2 2 0 0022 4H2a2 2 0 00-1.55.74A2 2 0 000 6v12a2 2 0 002 2h20a2 2 0 002-2V6a2 2 0 00-.45-1.26zm-5 1.62l-6.23 5.25-.1.09a.27.27 0 01-.38 0l-.1-.09-6.26-5.25h13.07zM22 18H2V6.05l8.42 7.09a2.27 2.27 0 003.16 0L22 6.05V18z"
                ></path>
            </svg>
        );
    }
}

export default IconTicketEmail;